import graphql__26dc5db37f6a2cc33bd6 from "./__generated__/UpdateContributionBookmarkMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__26dc5db37f6a2cc33bd6;

function updateContributionBookmark(contribution, bookmark, onCompleted) {
  const variables = { contributionId: contribution.id, bookmark };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted
  });
}

export { updateContributionBookmark };
